import { api } from "../api";


export const sendRabbitCommand = function (data, callback) {
    const user = JSON.parse(localStorage.getItem("user"));
    api.defaults.headers.authorization = `Bearer ${user.token}`;
    const URL = `/rabbit/send-command`;

    api
        .post(URL, data)
        .then((response) => {
            // console.log(JSON.stringify(response));
            callback(response.data);
        })
        .catch((error) => {
            callback([]);
            console.log("Error:. sendRabbitCommand " + error);
        });
};

export const createRabbitPayload = function (lockerId, cmd, payload) {

    const user = JSON.parse(localStorage.getItem("user"));

    const modelUser = {
        id: user?.data.id,
        name: user?.data.name
      };

    return {
        "lockerId": lockerId,
        "payload": {
            CMD: cmd,
            ...payload,
            user: modelUser
        }
    }
};